var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-button',_vm._g(_vm._b({attrs:{"color":_vm.color,"size":_vm.size},on:{"click":_vm.launchSetupWizard}},'core-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v("Create a Free Account")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }